import { add, sub } from '@ardoq/date-time';
import { minimumDisplayedGridUnitsForGridPrecision } from '../../consts';
import { DateRangeWithOptionalDates } from '../../types';
import { getSmallestTimelineGrid } from '../../utils';

export type DateRangePickerConfigForTimeline = {
  startDateConfig: { maxDate: Date } | undefined;
  endDateConfig: { minDate: Date } | undefined;
};

export const getDateRangePickerConfigForTimeline = ([
  startDate,
  endDate,
]: DateRangeWithOptionalDates): DateRangePickerConfigForTimeline => {
  const smallestGrid = getSmallestTimelineGrid();
  const incrementUnitQuantity =
    minimumDisplayedGridUnitsForGridPrecision[smallestGrid];

  // here we treat days as calendar dates, each day being fully incuded into the rage
  // the dates are set to midnight, therefore we subtract one day more than we add
  return {
    startDateConfig: endDate
      ? {
          maxDate: sub(endDate, {
            [smallestGrid]: Math.max(0, incrementUnitQuantity - 2),
          }),
        }
      : undefined,
    endDateConfig: startDate
      ? {
          minDate: add(startDate, {
            [smallestGrid]: Math.max(0, incrementUnitQuantity - 1),
          }),
        }
      : undefined,
  };
};
